// post reducers
export const GET_POST = "GET_POST";
export const GET_POSTS = "GET_POSTS";
export const ADD_POST = "ADD_POST";
export const ADD_POST_REQUEST = "ADD_POST_REQUEST";
export const POST_ERROR = "POST_ERROR";
export const CLEAR_POST = "CLEAR_POST";
export const APPLY_POST = "APPLY_POST";

// profile reducers
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILES = "GET_PROFILES";
export const PROFILE_ERROR = "PROFILE_ERROR";
export const CLEAR_PROFILE = "CLEAR_PROFILE";


// UI reducers
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const SERVER_ERROR = "SERVER_ERROR";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

// user reducers
export const SET_USER = "SET_USER";
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const LOADING_USER = "LOADING_USER";
export const APPLIED_POST = "APPLIED_POST";
